import { createStore } from 'vuex';
import MemberDAO from '../services/MemberDAO';

// const memberDAO = new MemberDAO('http://172.233.151.241:3000');
const memberDAO = new MemberDAO(process.env.VUE_APP_HTTP_BASE_URL);

const store = createStore({
    state: {
        user: null,
        registered_cards: [],
        registered_lps: [],
        offer_cards: [],

        parkingList: [],
        offerList:[],
        newsList:[],
        recruitList:[],
        lotteriesList:[],



        loginError: null,
        selectedParking: null
    },
    mutations: {
        setUser(state, user) {
            state.user = user;
            state.loginError = null;
        },
        setLoginError(state, error) {
            state.loginError = error;
        },
        setParkingList(state, parkingList) {
            // console.log('VUEX set parking list:', parkingList);
            state.parkingList = parkingList;
        },
        setOfferList(state, offerList) {
            // console.log('VUEX set offer list:', offerList);
            state.offerList = offerList;
        },
        addCard(state, card) {
            state.registered_cards.push(card);
            console.log('After add VUEX Registered cards:', state.registered_cards);

        },
        setRegisteredCards(state, cards) {
            state.registered_cards = cards;
            // console.log('VUEX Registered cards:', state.registered_cards);
        },
        setOfferCards(state, cards) {
            state.offer_cards = cards;
            // console.log('VUEX Offer cards:', state.offer_cards);
        },
        removeCard(state, cardId) {
            state.registered_cards = state.registered_cards.filter(card => card.id !== cardId);
            // console.log('After remove VUEX Registered cards:', state.registered_cards);

        }, 
        setRegisteredLPs(state, lps) {
            state.registered_lps = lps;
            // console.log('VUEX Registered LPs:', state.registered_lps);
        },
        addLP(state, lp) {
            state.registered_lps.push(lp);
            // console.log('After add VUEX Registered LPs:', state.registered_lps);
        },
        removeLP(state, lpId) {
            state.registered_lps = state.registered_lps.filter(lp => lp.lpid !== lpId);
            // console.log('After remove VUEX Registered LPs:', state.registered_lps);
        },

        SET_SELECTED_PARKING(state, parking) {
            // console.log('VUEX set selected parking:', parking);
            state.selectedParking = parking;
        }
    },
    actions: {


        
        async login({ commit }, { username, password }) {
            memberDAO.off('loginSuccess'); // Remove previous listeners
            memberDAO.off('loginFailure');

            commit('setLoginError', null);


            try {
                await new Promise((resolve, reject) => {
                    memberDAO.on('loginSuccess', (data) => {
                        // alert('Login successful!', JSON.stringify(data));
                        console.log('VUEX Login successful!', data.registered_cards);
                        console.log('VUEX Login successful! lps', data.registered_lps);
                        commit('setUser', username);
                        commit('setRegisteredCards', data.registered_cards);
                        commit('setRegisteredLPs', data.registered_lps);
                        resolve(data);
                    });

                    memberDAO.on('loginFailure', (message) => {
                        commit('setLoginError', message);
                        reject(message);
                    });

                    memberDAO.login(username, password); // Trigger login
                });
            } catch (error) {
                console.error('Login failed:', error);
            }
        },

        logout({ commit }) {
            // memberDAO.logout();
            commit('setUser', null);
        },

        fetchOfferCards({ commit }) {
            memberDAO.off('offerCards');

            memberDAO.on('offerCardsSuccess', (cards) => {
                commit('setOfferCards', cards);
            });

            memberDAO.gettttOfferCards(10000, 1);
        },

        initWebSocket({ commit }) {
            memberDAO.on('wsOpen', () => console.log('WebSocket opened.'));
            memberDAO.on('wsMessage', (data) => {
                switch (data.action) {
                    case 'read':
                        // commit('setUser', data.user);
                        break;
                    case 'parking-list':
                        commit('setParkingList', data.parkingList);
                        break;
                    case 'delete_card':
                        if (data.action === 'delete_card' && data.success) {
                            if (data.removed_card && data.removed_card.id) {
                                const deletedCardId = data.removed_card.id;
                                // this.local_registered_credit_cards = this.local_registered_credit_cards.filter(card => card.id !== deletedCardId);        
                                commit('removeCard', deletedCardId);
                                alert(`已刪除ID為 ${deletedCardId} 的信用卡。`, 'success');
                            } else {
                                alert('在 VUEX 中刪除信用卡失敗。', 'error');
                            }
                        }
                        else {
                            alert('刪除信用卡失敗。', 'error');
                        }
                        break;
                    case 'delete_lp':
                        console.log('VUEX delete_lp:', data);
                        if (data.action === 'delete_lp' && data.success) {
                            if (data.removed_lp && data.removed_lp.lpid) {
                                const deletedLPId = data.removed_lp.lpid;
                                // this.local_registered_lps = this.local_registered_lps.filter(lp => lp.id !== deletedLPId);
                                commit('removeLP', deletedLPId);
                                alert(`已刪除ID為 ${deletedLPId} 的車牌。`, 'success');
                            } else {
                                alert('刪除車牌失敗。', 'error');
                            }
                        }
                        else {
                            alert('刪除車牌失敗。', 'error');
                        }
                        break;
                }
            });
            memberDAO.on('wsClose', () => console.log('WebSocket closed.'));
        },

        // if (data.action === 'delete_card' && data.success) {
        //     if (data.removed_card && data.removed_card.id) {
        //         const deletedCardId = data.removed_card.id;
        //         this.local_registered_credit_cards = this.local_registered_credit_cards.filter(card => card.id !== deletedCardId);
        //         this.removeCardFromTable(deletedCardId);
        //         this.showAlert(`Credit card with ID ${deletedCardId} has been deleted.`, 'success');
        //     }
        // }        

        async addToRegisteredLP({ commit }, lp) {
            console.log('VUEX add LP:', lp);
            memberDAO.addLP(lp.id, lp.plate_number)
                .then((response) => {
                    console.log('LP added successfully:', response);
                    if (response.registered_lps) {
                        commit('setRegisteredLPs', response.registered_lps);
                    }
                    return true;
                    // Handle success (e.g., show a success message, update UI)
                })
                .catch((error) => {
                    console.error('Failed to add LP:', error);
                    return false;
                    // Handle failure (e.g., show an error message)
                });
        },

        async removeRegisteredLP(_, lpId) {
            memberDAO.deleteLP(lpId);
        },



        removeRegisteredCard(_, cardId) {
            memberDAO.deleteCard(cardId);

        },

   
        async addToRegisteredCard({ commit }, offer_card) {
            const card_name = offer_card.bank + " " + offer_card.name;
            console.log('VUEX add card:', offer_card);
        
            // Return a Promise that resolves/rejects based on the DAO operation
            return memberDAO
                .addCard(offer_card.id, card_name, offer_card.card_number, offer_card.expire_date)
                .then((response) => {
                    console.log('Card added successfully:', response);
                    if (response.registered_credit_cards) {
                        commit('setRegisteredCards', response.registered_credit_cards);
                    }
                    return { success: true }; // Resolve with success
                })
                .catch((error) => {
                    console.error('Failed to add card:', error);
                    return { success: false }; // Resolve with failure
                });
        },
        
        
        async addToRegisteredCardX({ commit }, offer_card) {
            // memberDAO.addCard(card.id, card.card_type, card.card_number);
            const card_name = offer_card.bank + " " + offer_card.name;
            console.log('VUEX add card:', offer_card);
            memberDAO.addCard(offer_card.id, card_name, offer_card.card_number)
                .then((response) => {
                    console.log('Card added successfully:', response);
                    if (response.registered_credit_cards) {
                        commit('setRegisteredCards', response.registered_credit_cards);
                    }
                    return true;
                    // Handle success (e.g., show a success message, update UI)
                })
                .catch((error) => {
                    console.error('Failed to add card:', error);
                    return false;
                    // Handle failure (e.g., show an error message)
                });

        },

        getParkingList({ commit },{row, page}) {
            console.log('VUEX get parking list:', row, page);
            memberDAO.getParkingList(row, page)
            .then((response) => {
                console.log('Parking list:', response.parkings);
                commit('setParkingList', response.parkings);
                // console.log('VUEX Parking list:', this.parkingList);
            }
            )
            .catch((error) => {
                console.error('Failed to get parking list:', error);
            });
        },


        getOfferList({ commit },{row, page}) {
            console.log('VUEX get offer list:', row, page);
            memberDAO.getOfferList(row, page)
            .then((response) => {
                console.log('Offer list:', response.offers);
                commit('setOfferList', response.offers);
                // console.log('VUEX Parking list:', this.parkingList);
            }
            )
            .catch((error) => {
                console.error('Failed to get offer list:', error);
            });
        },        

        setSelectedParking({ commit }, parking) {
            commit('SET_SELECTED_PARKING', parking);
          },



    },
    getters: {
        user: (state) => state.user,
        parkingList: (state) => state.parkingList,
        offer_cards: (state) => state.offer_cards,
        registered_cards: (state) => state.registered_cards,
        registered_lps: (state) => state.registered_lps,
        loginError: (state) => state.loginError,
        selectedParking: (state) => state.selectedParking,

        offerList: (state) => state.offerList,

    }
});

export default store;
